<template>
  <div class="dialog-batch-config">
    <Form :model="schoolBatchData" :label-width="240" ref="editForm" :rules="validateRules">
      <FormItem label="硕士论文单篇管理费用：" prop="mManageFee">
        <Input v-model="schoolBatchData.mManageFee" :autofocus="true" placeholder="请输入硕士论文单篇管理费"></Input>
      </FormItem>
      <FormItem label="硕士论文单篇专家评审费：" prop="mExpertFee">
        <Input v-model="schoolBatchData.mExpertFee" :autofocus="true" placeholder="请输入硕士论文单篇专家评审费"></Input>
      </FormItem>
      <FormItem label="博士论文单篇管理费用：" prop="dManageFee">
        <Input v-model="schoolBatchData.dManageFee" :autofocus="true" placeholder="请输入博士论文单篇管理费用"></Input>
      </FormItem>
      <FormItem label="博士论文单篇专家评审费：" prop="dExpertFee">
        <Input v-model="schoolBatchData.dExpertFee" :autofocus="true" placeholder="请输入博士论文单篇专家评审费称"></Input>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import ElementDate from '../../../components/elements/date';
export default {
  name: 'resetPwd',
  components: {ElementDate},
  props: {
    query: ''
  },
  data () {
    return {
      userId: '',
      schoolBatchId: '',
      queryArr: '',
      schoolBatchData: {
        mManageFee: '',
        mExpertFee: '',
        dManageFee: '',
        dExpertFee: ''
      },
      validateRules: {
        mManageFee: [{required: true, message: '硕士管理费不能为空', trigger: 'blur'}],
        mExpertFee: [{required: true, message: '硕士专家费不能为空', trigger: 'blur'}],
        dManageFee: [{required: true, message: '博士管理费不能为空', trigger: 'blur'}],
        dExpertFee: [{required: true, message: '博士专家费不能为空', trigger: 'blur'}]
      }
    }
  },
  created () {
    this.queryArr = this.query.split('_')
    this.schoolBatchData.sendType = this.queryArr[0]
    if (this.queryArr.length > 1) {
      this.schoolBatchId = this.queryArr[1]
      this.fetchBatchConfig();
    }
  },
  methods: {
    // 确定回调事件
    dialogComfirm () {
      return new Promise((resolve, reject) => {
        const _self = this;
        _self.$refs['editForm'].validate((valid) => {
          if (valid) {
            _self.post('/school/schoolBatch/changeBatchFee', {
              id: _self.schoolBatchId,
              mManageFee: _self.schoolBatchData.mManageFee,
              mExpertFee: _self.schoolBatchData.mExpertFee,
              dManageFee: _self.schoolBatchData.dManageFee,
              dExpertFee: _self.schoolBatchData.dExpertFee
            }).then(res => {
              _self.$Message.success(res.msg);
              resolve(res);
            }).catch(error => {
              reject(error);
            });
          } else {
            reject(new Error());
          }
        });
      });
    },
    fetchBatchConfig () {
      const _self = this
      _self.fetch('/school/schoolBatch/info/' + this.schoolBatchId).then(res => {
        _self.schoolBatchData = res.data
        _self.formLoading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/dialogs/customerThesis/feeManage.vue